import { render, staticRenderFns } from "./SimpleListAdd.vue?vue&type=template&id=5cd52232"
import script from "./SimpleListAdd.vue?vue&type=script&lang=js"
export * from "./SimpleListAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports